import { useEffect } from "react";
import { X } from "lucide-react";

export default function GalleryGrid({ images = [], open = false, onClose, onSelect, alt = "" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid="gallery-grid"
      className="fixed inset-0 z-[900] bg-[#FAFAF8] overflow-y-auto"
    >
      {/* Sticky top bar */}
      <div className="sticky top-0 z-10 bg-[#FAFAF8]/95 backdrop-blur-sm border-b border-[#1C1C1A]/10 flex items-center justify-between px-6 sm:px-10 lg:px-16 py-5">
        <div>
          <p className="font-serif text-xl font-light text-[#1C1C1A]">{alt}</p>
          <p className="text-[0.6rem] uppercase tracking-[0.18em] text-[#6B6B65] mt-0.5">{images.length} photos</p>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close gallery"
          data-testid="gallery-grid-close"
          className="flex items-center gap-2 text-[0.65rem] uppercase tracking-[0.18em] text-[#6B6B65] hover:text-[#1C1C1A] transition-colors"
        >
          Close <X size={16} strokeWidth={1.5} />
        </button>
      </div>

      {/* Grid */}
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-10">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-1.5">
          {images.map((src, idx) => (
            <button
              key={src + idx}
              type="button"
              onClick={() => onSelect(idx)}
              data-testid={`gallery-grid-img-${idx}`}
              aria-label={`View photo ${idx + 1}`}
              className="group relative overflow-hidden img-zoom-wrap aspect-[4/3] cursor-zoom-in"
            >
              <img
                src={src}
                alt={`${alt} — photo ${idx + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />
              <span className="absolute bottom-2 left-3 text-[0.58rem] uppercase tracking-[0.18em] text-white/70 opacity-0 group-hover:opacity-100 transition-opacity">
                {String(idx + 1).padStart(2, "0")}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
